import { createFileRoute } from '@tanstack/react-router';
import { PersonActivityRoute } from './-route-wrappers';

/** The person profile's Activity tab at its own URL (FPS-2712). */
function PersonActivityIndexRoute() {
  return <PersonActivityRoute />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/people/$personId/activity/')({
  component: PersonActivityIndexRoute,
});
